// src/components/PublicRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { token, user } = useAuth();
  
  // If user is authenticated, redirect to chat
  if (token && user) {
    return <Navigate to="/chat" replace />;
  }
  
  return children;
};

export default PublicRoute;
